<template>
    <!-- 对话框 -->
    <el-drawer title="添加商家信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <template>

                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">


                    <el-form-item label="分润模式配置:" label-width='120px'>
                       <div style="display:flex;">
                         <el-select
                            v-model="submit_data.type"
                            :placeholder="submit_rules.type.placeholder"
                            style="width: 150px; margin-right: 20px;"
                            clearable
                        >
                            <el-option
                                    label="百分比"
                                    value="1"
                            >
                            </el-option>
                            <el-option
                                    label="金额"
                                    value="0"
                            >
                            </el-option>
                        </el-select>
                        <!-- 分润模式配置不为空时展示如下输入框，如果分润模式为百分比，则输入框后面的单位是% 否则为元 -->
                        <div v-if="submit_data.type!=''">
                            <el-input v-model="submit_data.share_money" :placeholder="submit_rules.share_money.placeholder"
                            style="width: 100px; margin-right:5px"></el-input>
                            {{submit_data.type == '1'?'%':'元'}}
                        </div>
                       </div>
                    </el-form-item>


                    <el-form-item label="司机承担:" label-width='120px'>
                        <el-input v-model="submit_data.driver_bear" :placeholder="submit_rules.driver_bear.placeholder" style="width: 150px; margin-right:5px">
                        </el-input>元
                    </el-form-item>

                    <el-form-item label="活动指定人群:" label-width='120px'>
                        <el-select
                            v-model="submit_data.face_new"
                            :placeholder="submit_rules.face_new.placeholder"
                            style="width: 150px; margin-right: 20px;"
                            clearable
                        >
                            <el-option label="新用户" value="1">
                            </el-option>

                            <el-option label="所有用户" value="0">
                            </el-option>
                        </el-select>

                    </el-form-item>


                    <el-form-item label="指定计费模式:" label-width='120px'>
                        <el-select
                                    v-model="value_mode_code"
                                    placeholder="请选择模式"
                                    @visible-change="modeVisibleChange"
                                    @change="modeChange"
                                    clearable
                                    @keyup.enter.native="searchOrderLists"
                                    style="width: 150px; margin-right: 20px;"
                            >
                                <el-option
                                        v-for="item in options_mode_code"
                                        :key="item.value"
                                        :label="item.order_mode.name"
                                        :value="item.order_mode.order_mode_code"
                                >
                                </el-option>

                                <selectPages
                                        :search_data="mode_options_data"
                                        :result_data="selectPages_data"
                                        @selectPages_function="selectPages_function"
                                ></selectPages>

                            </el-select>

                    </el-form-item>
                    <el-form-item label="批量创建:" label-width='120px'>
                        <el-input v-model="submit_data.num" :placeholder="submit_rules.num.placeholder" style="width: 150px; margin-right:5px">
                        </el-input>
                        
                    </el-form-item>
                    <div style="font-size: 12px;color:red;text-indent:120px">单次批量创建最多50</div>
                    


                </el-form>


                <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules"
                               :url="submit_url" :JSON_Boolean="false"></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                    
                </div>

            </template>


        </div>


    </el-drawer>
</template>

<script>

    var _this;
    export default {
        props: {
            'isShow': Boolean
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;

            }
        },
        data() {
            return {


                show: false,
                form: {
                    data: ''
                },

                value_mode_code: '',

                options_mode_code: [],

                mode_options_data: {
                    page: 1,
                    limit: 5,
                    status: '1'
                },

                selectPages_data: [],

                submit_url: '/business/addBusiness',
                // 表单数据
                submit_data: {
                    type: '',
                    share_money: '',
                    driver_bear: '',
                    face_new: '',
                    num: 1,
                    order_mode_code: ''
                    
            
                },

                submit_rules: {
                    
                    type: {
                        placeholder: '分润模式',
                        rules: {
                            required: true,
                            message: '模式错误',
                            regulation: 'gt_str',
                            rulesData: '0|1'
                        }
                    },
                    share_money: {
                        placeholder: '金额或比例',
                        rules: {
                            required: true,
                            message: '分润金额或比例为0-99的数字',
                            regulation: 'between',
                            rulesData: [0,99]
                        }
                    },
                    driver_bear: {
                        placeholder: '司机承担',
                        rules: {
                            required: true,
                            message: '司机承担为不小于0的数字',
                            regulation: 'egt',
                            rulesData: 0
                        }
                    },
                    face_new: {
                        placeholder: '活动指定人群',
                        rules: {
                            required: true,
                            message: '是否限制为新用户',
                            regulation: 'gt_str',
                            rulesData: '0|1'
                        }
                    },
                    order_mode_code: {
                        placeholder: '请选择计费模式',
                        rules: {
                            required: false,
                            message: '计费模式',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }
                    },
                    num: {
                        placeholder: '单次批量最多50',
                        rules: {
                            required: true,
                            message: '批量创建为1-50的数字',
                            regulation: 'between',
                            rulesData: [1, 50]
                        }
                    },
                },

            };
        },
        created() {

            _this = this;

        },
        methods: {
                

            // 关闭方法
            closeDialog() {
                _this.show = false;
                for (const key in _this.submit_data) {
                    _this.submit_data[key] = '';
                }
                _this.value_mode_code = '';
                _this.submit_data.num = 1;
               
            },

            //搜索的下拉框弹出触发
            modeVisibleChange(val) {
                _this.orderModeList();
            },

            modeChange(val) {
                _this.submit_data.order_mode_code = val;
            },

            searchOrderLists() {
                if (
                    (_this.search_data.status == 'serving' && _this.search_data.complete_fixed_array.length != 0) ||
                    (_this.search_data.status == 'proceed' && _this.search_data.complete_fixed_array.length != 0) ||
                    (_this.search_data.status == 'new' && _this.search_data.complete_fixed_array.length != 0)
                ) {
                    _this.$message.error('当前状态无完成时间数据,不能进行搜索');

                    return;
                }

                _this.search_data.page = 1;
                _this.orderLists();
            },

            selectPages_function(search_data) {
                _this.mode_options_data = search_data;

                _this.orderModeList();
            },

            // 搜索订单列表
            orderLists() {
                _this.tableData = [];

                _this
                    .$post('/order/orderHistory', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;



                        _this.platform_select_array = res.data[0].platform.select_array;
                        _this.port_select_array = res.data[0].port.select_array;
                        _this.vip_select_array = res.data[0].consumer_vip.select_array;
                        _this.is_new_visit_array = res.data[0].is_new_visit.select_array;

                        // console.log(_this.tableData[0].platform);


                    })
                    .catch((err) => {});
            },

            orderModeList() {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/order/orderModeLists', _this.mode_options_data)
                    .then((res) => {
                        _this.selectPages_data = res;
                        _this.options_mode_code = res.data;
                    })
                    .catch((err) => {});
            },

            

            // 提交
            onSubmitDig() {
                _this.$emit('onSubmit');
                _this.closeDialog();
            }
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>